import type { SandboxCourse } from '../utils/sandboxCourseApi';

export type FlatLesson = {
    _id: string;
    title: string;
    moduleTitle?: string;
    has_assignment?: boolean;
    assignment_brief?: string;
};

export type SandboxEnrollmentRow = {
    _id: string;
    progress_percent?: number;
    last_lesson?: string | null;
    updatedAt?: string;
    course: SandboxCourse;
};

export function flattenSandboxLessons(course?: SandboxCourse | null): FlatLesson[] {
    const out: FlatLesson[] = [];
    for (const mod of course?.modules || []) {
        for (const lesson of mod.lessons || []) {
            if (!lesson?._id) continue;
            out.push({
                _id: String(lesson._id),
                title: lesson.title || 'Lesson',
                moduleTitle: mod.title,
                has_assignment: Boolean(lesson.has_assignment),
                assignment_brief: lesson.assignment_brief,
            });
        }
    }
    return out;
}

export function enrollmentResumeMeta(enrollment: SandboxEnrollmentRow) {
    const lessons = flattenSandboxLessons(enrollment.course);
    const total = lessons.length;
    const lastId = enrollment.last_lesson ? String(enrollment.last_lesson) : '';
    let index = lastId ? lessons.findIndex(l => String(l._id) === lastId) : -1;
    if (index < 0) index = 0;
    const lesson = lessons[index] || null;
    const percent = Math.max(0, Math.min(100, Math.round(Number(enrollment.progress_percent) || 0)));
    return {
        lessons,
        total,
        index,
        lessonNumber: total ? index + 1 : 0,
        lesson,
        percent,
        resumeLessonId: lesson?._id || null,
    };
}
